import { fromJS } from 'immutable';
import { FETCH_TYPES, FETCH_TYPES_ERROR, FETCH_TYPES_SUCCESS, FETCH_INCIDENT_TYPES, FETCH_INCIDENT_TYPES_SUCCESS, FETCH_INCIDENT_TYPES_ERROR } from './constants';

const typesSuccess = (state, payload) => {
  return state.set('types', {
    count: payload.length,
    results: payload,
    loading: false
  });
};

const typesFetchLoading = (state, value) => {
  return state.set('types', {
    loading: value
  });
};

const incidentTypesSuccess = (state, payload) => {
  return state.set('incidentTypes', {
    count: payload.length,
    results: payload,
    loading: false
  });
};

const incidentTypesFetchLoading = (state, value) => {
  return state.set('incidentTypes', {
    loading: value
  });
};

export const storeName = 'dictionary-types';

const initialState = fromJS({
  types: {
    count: 0,
    results: [],
    loading: false
  },
  incidentTypes: {
    count: 0,
    results: [],
    loading: false
  }
});

export default {
  [storeName]: (state = initialState, action) => {
    switch (action.type) {
      case FETCH_TYPES:
        return typesFetchLoading(state, true);
      case FETCH_TYPES_SUCCESS:
        return typesSuccess(state, action.payload);
      case FETCH_TYPES_ERROR:
        return typesFetchLoading(state, true);
      case FETCH_INCIDENT_TYPES:
        return incidentTypesFetchLoading(state, true);
      case FETCH_INCIDENT_TYPES_SUCCESS:
        return incidentTypesSuccess(state, action.payload);
      case FETCH_INCIDENT_TYPES_ERROR:
        return incidentTypesFetchLoading(state, true);
      default:
        return state;
    }
  }
};
